import { useState } from "react";
import { mockSupportTickets } from "@/mocks/dealerData";

export default function AdminSupportPage() {
  const [tickets, setTickets] = useState(mockSupportTickets);
  const [expandedTicket, setExpandedTicket] = useState<string | null>(null);
  const [replyText, setReplyText] = useState("");
  const [replyingTo, setReplyingTo] = useState<string | null>(null);

  const handleReply = (ticketId: string) => {
    if (!replyText.trim()) return;
    setTickets((prev) =>
      prev.map((t) =>
        t.id === ticketId
          ? {
              ...t,
              replies: [...t.replies, { from: "admin", message: replyText, date: new Date().toISOString() }],
            }
          : t
      )
    );
    setReplyText("");
    setReplyingTo(null);
  };

  const closeTicket = (ticketId: string) => {
    setTickets((prev) =>
      prev.map((t) => (t.id === ticketId ? { ...t, status: "closed" } : t))
    );
  };

  const reopenTicket = (ticketId: string) => {
    setTickets((prev) =>
      prev.map((t) => (t.id === ticketId ? { ...t, status: "open" } : t))
    );
  };

  const openCount = tickets.filter((t) => t.status === "open").length;

  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div>
          <h4 className="text-lg font-semibold text-foreground-950"><a id="admin-support">Destek Talepleri</a></h4>
          <p className="text-sm text-foreground-500 mt-0.5">{tickets.length} talep, {openCount} açık</p>
        </div>
      </div>

      <div className="space-y-3">
        {tickets.map((ticket) => (
          <div key={ticket.id} className={`bg-background-50 border rounded-xl overflow-hidden ${ticket.status === "open" ? "border-accent-200/70" : "border-background-200/70"}`}>
            <div className="p-4 flex items-start justify-between cursor-pointer" onClick={() => setExpandedTicket(expandedTicket === ticket.id ? null : ticket.id)}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${ticket.status === "open" ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-700"}`}>
                    {ticket.status === "open" ? "Açık" : "Kapalı"}
                  </span>
                  <span className="text-xs text-foreground-400">{new Date(ticket.date).toLocaleDateString("tr-TR")}</span>
                </div>
                <h5 className="font-medium text-foreground-950 text-sm">{ticket.subject}</h5>
                <p className="text-sm text-foreground-500 mt-1 line-clamp-2">{ticket.message}</p>
              </div>
              <div className="flex items-center gap-2 ml-3 shrink-0">
                {ticket.status === "open" ? (
                  <button onClick={(e) => { e.stopPropagation(); closeTicket(ticket.id); }} className="px-3 py-1.5 bg-primary-100 text-primary-700 rounded-lg text-xs font-medium hover:bg-primary-200 transition-colors cursor-pointer whitespace-nowrap">Kapat</button>
                ) : (
                  <button onClick={(e) => { e.stopPropagation(); reopenTicket(ticket.id); }} className="px-3 py-1.5 bg-background-100 text-foreground-600 rounded-lg text-xs font-medium hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap">Yeniden Aç</button>
                )}
                <i className={`${expandedTicket === ticket.id ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-foreground-400`}></i>
              </div>
            </div>

            {expandedTicket === ticket.id && (
              <div className="px-4 pb-4 border-t border-background-200/70 pt-3 space-y-3">
                {ticket.replies.map((reply, i) => (
                  <div key={i} className={`rounded-lg p-3 ${reply.from === "admin" ? "bg-accent-100 ml-4" : "bg-background-100 mr-4"}`}>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-medium text-foreground-700">{reply.from === "admin" ? "Admin Yanıtı" : "Bayi"}</span>
                      <span className="text-xs text-foreground-400">{new Date(reply.date).toLocaleString("en-US")}</span>
                    </div>
                    <p className="text-sm text-foreground-700">{reply.message}</p>
                  </div>
                ))}

                {replyingTo === ticket.id ? (
                  <div className="space-y-2">
                    <textarea value={replyText} onChange={(e) => setReplyText(e.target.value)} rows={3} maxLength={500} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 resize-none" placeholder="Yanıtınızı yazın..."></textarea>
                    <div className="flex gap-2">
                      <button onClick={() => { setReplyingTo(null); setReplyText(""); }} className="px-3 py-1.5 bg-background-100 border border-background-200/70 text-foreground-600 rounded-lg text-xs font-medium hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap">İptal</button>
                      <button onClick={() => handleReply(ticket.id)} className="px-3 py-1.5 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap">Yanıtla</button>
                    </div>
                  </div>
                ) : (
                  ticket.status === "open" && (
                    <button onClick={() => setReplyingTo(ticket.id)} className="flex items-center gap-1.5 text-xs font-medium text-accent-600 hover:text-accent-700 cursor-pointer">
                      <i className="ri-reply-line"></i> Yanıt Yaz
                    </button>
                  )
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}